import React from 'react';

import {
  Input,
  InputProps,
} from '@ast/magma/components/input';

// alphabetic, apostrophes, hyphens, dots, spaces (but not only spaces)
export const PRIMARY_NAME_PATTERN = /^[a-z\s\-.']+$/i;
export const PRIMARY_NAME_LENGTH = 22;

export type PrimaryNameFieldProps = InputProps
& React.InputHTMLAttributes<HTMLInputElement>
& React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export type PrimaryNameFieldRef = HTMLInputElement & HTMLTextAreaElement;

export const PrimaryNameField = React.forwardRef((
  props: PrimaryNameFieldProps,
  ref: React.Ref<PrimaryNameFieldRef>,
) => (
  <Input
    type="text"
    {...props}
    ref={ref}
  />
));
